
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState, Fragment, useEffect } from 'react';
import { TableCell, TableRow, TextField } from '@mui/material';
import { Space, Image, Dropdown, Menu } from "antd";
import { useSelector } from "react-redux";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { stockOnHandHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import SearchText from '../../../../Shared/components/SearchText';
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import { getColumnWidth, currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { emptyValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { Link, NavLink } from "react-router-dom";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { toast } from 'react-toastify';


export const ListTable = (props) => {
    const { details, loadMore, sortOrder, crudActions, dispatch, sortBy, topBar, onRequestSort } = props;
    const { editLoader, editDetails, editError } = useSelector(state => state.crudReducer);

    const [priceVisible, setPriceVisible] = useState(false);
    const [costPrice, setCostPrice] = useState('');
    const [errorCostPrice, setErrorCostPrice] = useState('');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const handleSubmit = () => {
        let emptyCostPrice = emptyValidation('Cost Price', costPrice);
        if (emptyCostPrice.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "client-products",
                id: priceVisible,
                title: "Client Products",
                details: { costPrice: parseFloat(costPrice) }
            })
        } else {
            setErrorCostPrice(emptyCostPrice.errors)
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setCostPrice(''); setPriceVisible(''); setErrorCostPrice('');
            toast(`Product Cost Price has been updated successfully`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast(`Something went worng`);
        }
    }, [editDetails, editError])

    const classes = customStyles();
    return (
        <Fragment>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreTask={() => { }}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                loadMoreContent={false}
                heads={stockOnHandHead}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={stockOnHandHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 0) }}>
                                                    <Link style={{ width: getColumnWidth(stockOnHandHead, 0) }} id={idNamingConversion('View_' + data.productId, 'stockOnHand', 'Link')}
                                                        to={`/product/inventory/stock-on-hand/${AESEncrypt(data.productId)}/view`} className={clsx(classes.color, classes.wordBreak, classes.disBlock, classes.bold)}>
                                                        {topBar?.displayType === 'description' ? data?.description : data?.productName}
                                                    </Link></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 1) }}>
                                                    <span style={{ width: getColumnWidth(stockOnHandHead, 1) }}>{data?.physicalQtyUnit || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 2) }}>
                                                    <span style={{ width: getColumnWidth(stockOnHandHead, 2) }}>{data?.unitName || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 3) }}>
                                                    <span style={{ width: getColumnWidth(stockOnHandHead, 3) }}>{data?.physicalQtySkuUnit || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 4) }}>
                                                    <span style={{ width: getColumnWidth(stockOnHandHead, 4) }}>{data?.skuUnitName || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stockOnHandHead, 5) }}>
                                                    <span style={{ width: getColumnWidth(stockOnHandHead, 5) }}>{data?.costAmount ? `₹ ${currencyFormat(data?.costAmount)}` : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        <Link to={`/product/inventory/stock-on-hand/${AESEncrypt(data.productId)}/view`} id={idNamingConversion('View_' + data.id, 'stockOnHand', 'Icon')}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </Link>
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    <Menu.Item><NavLink id={idNamingConversion('Change Cost Price_' + data.id, 'customerProfile', 'Link')} to={`#`} onClick={() => setPriceVisible(data?.productId)}>Change Cost Price</NavLink></Menu.Item>
                                                                    <Menu.Item><NavLink id={idNamingConversion('Change Cost Price_' + data.id, 'customerProfile', 'Link')} to={`/product/inventory/inventory-transaction/${AESEncrypt(data.productId)}`}>Inventory Transactions</NavLink></Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'stockOnHand', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={stockOnHandHead.length}><SearchText /></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <CustomModal
                onClose={(v) => { setCostPrice(''); setPriceVisible(''); setErrorCostPrice(''); }}
                yesButton={'OK'}
                noButton={'Cancel'}
                title={'Change Cost Price'}
                visible={priceVisible ? true : false}
                onOpen={() => handleSubmit()}
                loading={editLoader}
                yesId={idNamingConversion('OK', 'stockOnHand', 'Button')}
                noId={idNamingConversion('Cancel', 'stockOnHand', 'Button')}
                text={
                    <TextField autoComplete='one-time-code'
                        label={["Cost Price ", <span key={"Cost Price"} className={classes.colorRedRequired}> *</span>]}
                        fullWidth
                        name="costPrice"
                        type="number"
                        id={idNamingConversion('Cost Price', 'stockOnHand', 'TextField')}
                        error={errorCostPrice && true}
                        helperText={errorCostPrice}
                        variant={'standard'}
                        value={costPrice || ''}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                handleSubmit();
                            }
                        }}
                        InputProps={{
                            classes: {
                                input: classes.textFieldColor
                            },
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom
                        }}
                        onChange={(e) => setCostPrice(e.target.value)}
                    />
                }
            />
        </Fragment>
    )
}